import { Button, TextField } from '@mui/material'
import React, { useState } from 'react'
import { AuthAPI } from '../../api/AuthAPI';
import { useNavigate } from 'react-router';
import ffpassImg from '../../assets/images/mobile-password-forgot.png'
import ReCAPTCHA from 'react-google-recaptcha';
import PopUpAlert from '../../component/PopUpAlert';
const ForgotPassword = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [error, setError] = useState("");
    const [message, setMessage] = useState({type:'',content:''})
    const [captchaVerified, setCaptchaVerified] = useState(false);

    const handleEmailSent = async (event) => {
        event.preventDefault();
        setMessage({ type: '', content:'' });
        if (!email) {
            setError(true);
            return;
        }
        try {
            const forgotPasswordData = { email: email };
            await AuthAPI.forgotPassword(forgotPasswordData).then((resp) => {
                navigate("/email-sent", {state:{userEmail:email}});
            })
        } catch (err) {
            console.error('err', err)
            setMessage({type:'error',content:err?.response?.data?.Data})
        }
        //API call for email sent
    }

    const verifyCaptcha = async (data) => {
        try {
            const response = await AuthAPI.postVerifyCaptcha(data);
            setCaptchaVerified(response.Data);
        } catch (error) {
        }
    }

    return (
        <div className='forgot_pass_container'>
            <PopUpAlert message={message.content} type={message.type} />
            <form onSubmit={handleEmailSent} className='forgot_pass_form_body'>
                <img src={ffpassImg} alt="" />
                <p>Have you forgotten your password? Let us assist you with the reset.</p>
                <p>

                    To reset your password, please provide the email address linked to your account. You will receive a token by email.

                </p>
                <TextField
                    error={error}
                    helperText={error && 'Email required'}
                    className='forgot-pass-text-input'
                    type='email'
                    onChange={(e) => setEmail(e.target.value)}
                    label="Email" />
                <ReCAPTCHA
                    style={{ marginTop: '20px' }}
                    sitekey={import.meta.env.VITE_APP_CAPTCHA_SITE_KEY}
                    onChange={(data) => verifyCaptcha(data)}
                />
                <div className='forgot_pass_submit_btn'>
                    <Button disabled={!captchaVerified} type='submit' variant='contained'>submit</Button>
                </div>
            </form>
        </div>
    )
}

export default ForgotPassword